import Vue from 'vue'
import App from './Index.vue'
import {getHibirdConfig, initJSBridge, sendData} from "@/utils/JSBridge";
import {pageConfig} from "@/config/clientPageConfig";
import '../common'


initJSBridge(function (bridge) {});

sendData(getHibirdConfig(pageConfig.bridgeConfig));


new Vue({
  render: h => h(App)
}).$mount('#app');
